// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.05%27%3E%3Ccircle cx=%2730%27 cy=%2730%27 r=%272%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  line-height: 1.6;
}

.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1200px;
  width: 100%;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  min-height: 600px;
}

.login-left {
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  position: relative;
  overflow: hidden;
}

.login-left::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    repeat;
  animation: float 20s linear infinite;
}

@keyframes float {
  0% {
    transform: translateX(0) translateY(0);
  }
  100% {
    transform: translateX(-60px) translateY(-60px);
  }
}

.brand-section {
  position: relative;
  z-index: 2;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;
}

.brand-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  padding: 12px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.company-name {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 4px;
  letter-spacing: -0.5px;
}

.company-tagline {
  font-size: 14px;
  opacity: 0.9;
  font-weight: 400;
}

.welcome-content {
  max-width: 400px;
}

.welcome-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 16px;
  line-height: 1.3;
}

.welcome-description {
  font-size: 16px;
  opacity: 0.9;
  margin-bottom: 32px;
  line-height: 1.6;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  opacity: 0.9;
}

.feature-dot {
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  flex-shrink: 0;
}

.login-right {
  padding: 60px 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafbfc;
}

.login-form-container {
  width: 100%;
  max-width: 400px;
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
}

.form-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.form-subtitle {
  color: #666;
  font-size: 14px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  width: 18px;
  height: 18px;
  color: #9ca3af;
  z-index: 2;
}

.form-group .form-input {
  width: 100%;
  height: 48px;
  padding: 0 16px 0 40px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #1a1a1a;
  background: white;
  transition: all 0.2s ease;
  outline: none;
}

.form-input:focus {
  border-color: #0d5787;
  box-shadow: 0 0 0 3px rgba(13, 87, 135, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.password-toggle {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s ease;
}

.password-toggle:hover {
  color: #0d5787;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
}

.remember-me input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border: 1.5px solid #d1d5db;
  border-radius: 3px;
  appearance: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.remember-me input[type="checkbox"]:checked {
  background: #0d5787;
  border-color: #0d5787;
}

.remember-me input[type="checkbox"]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 10px;
  font-weight: bold;
}

.forgot-link {
  color: #0d5787;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.forgot-link:hover {
  color: #69aed2;
}

.submit-button {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
}

.submit-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(13, 87, 135, 0.3);
}

.submit-button:active {
  transform: translateY(0);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.form-footer {
  text-align: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.footer-text {
  color: #6b7280;
  font-size: 14px;
}

.contact-link {
  color: #0d5787;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.contact-link:hover {
  color: #69aed2;
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-grid {
    grid-template-columns: 1fr;
    max-width: 400px;
    /* margin: 20px; */
  }

  .login-left {
    padding: 40px 30px;
    text-align: center;
  }

  .welcome-title {
    font-size: 24px;
  }

  .company-name {
    font-size: 28px;
  }

  .login-right {
    padding: 40px 30px;
  }

  .brand-logo {
    justify-content: center;
  }

  .welcome-content {
    max-width: none;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }

  .login-left {
    padding: 30px 20px;
  }

  .login-right {
    padding: 30px 20px;
  }

  .company-name {
    font-size: 24px;
  }

  .welcome-title {
    font-size: 20px;
  }
}

/* Focus styles for accessibility */
.submit-button:focus-visible,
.form-input:focus-visible,
.password-toggle:focus-visible {
  outline: 2px solid #0d5787;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/login/login.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;cACY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ;UACQ;EACR,oCAAoC;AACtC;;AAEA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    sans-serif;\n  line-height: 1.6;\n}\n\n.login-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.login-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  max-width: 1200px;\n  width: 100%;\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);\n  min-height: 600px;\n}\n\n.login-left {\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  padding: 60px 50px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: white;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-left::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 200%;\n  height: 200%;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")\n    repeat;\n  animation: float 20s linear infinite;\n}\n\n@keyframes float {\n  0% {\n    transform: translateX(0) translateY(0);\n  }\n  100% {\n    transform: translateX(-60px) translateY(-60px);\n  }\n}\n\n.brand-section {\n  position: relative;\n  z-index: 2;\n}\n\n.brand-logo {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 40px;\n}\n\n.brand-icon {\n  width: 48px;\n  height: 48px;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 12px;\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n}\n\n.company-name {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 4px;\n  letter-spacing: -0.5px;\n}\n\n.company-tagline {\n  font-size: 14px;\n  opacity: 0.9;\n  font-weight: 400;\n}\n\n.welcome-content {\n  max-width: 400px;\n}\n\n.welcome-title {\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  line-height: 1.3;\n}\n\n.welcome-description {\n  font-size: 16px;\n  opacity: 0.9;\n  margin-bottom: 32px;\n  line-height: 1.6;\n}\n\n.feature-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.feature-dot {\n  width: 8px;\n  height: 8px;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.login-right {\n  padding: 60px 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fafbfc;\n}\n\n.login-form-container {\n  width: 100%;\n  max-width: 400px;\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.form-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.form-subtitle {\n  color: #666;\n  font-size: 14px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 16px;\n  width: 18px;\n  height: 18px;\n  color: #9ca3af;\n  z-index: 2;\n}\n\n.form-group .form-input {\n  width: 100%;\n  height: 48px;\n  padding: 0 16px 0 40px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1a1a1a;\n  background: white;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.form-input:focus {\n  border-color: #0d5787;\n  box-shadow: 0 0 0 3px rgba(13, 87, 135, 0.1);\n}\n\n.form-input::placeholder {\n  color: #9ca3af;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 16px;\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: color 0.2s ease;\n}\n\n.password-toggle:hover {\n  color: #0d5787;\n}\n\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 8px 0;\n}\n\n.remember-me {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #374151;\n}\n\n.remember-me input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 3px;\n  appearance: none;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.remember-me input[type=\"checkbox\"]:checked {\n  background: #0d5787;\n  border-color: #0d5787;\n}\n\n.remember-me input[type=\"checkbox\"]:checked::after {\n  content: \"✓\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.forgot-link {\n  color: #0d5787;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.forgot-link:hover {\n  color: #69aed2;\n}\n\n.submit-button {\n  width: 100%;\n  height: 48px;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.submit-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(13, 87, 135, 0.3);\n}\n\n.submit-button:active {\n  transform: translateY(0);\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.form-footer {\n  text-align: center;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.footer-text {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.contact-link {\n  color: #0d5787;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.contact-link:hover {\n  color: #69aed2;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .login-grid {\n    grid-template-columns: 1fr;\n    max-width: 400px;\n    /* margin: 20px; */\n  }\n\n  .login-left {\n    padding: 40px 30px;\n    text-align: center;\n  }\n\n  .welcome-title {\n    font-size: 24px;\n  }\n\n  .company-name {\n    font-size: 28px;\n  }\n\n  .login-right {\n    padding: 40px 30px;\n  }\n\n  .brand-logo {\n    justify-content: center;\n  }\n\n  .welcome-content {\n    max-width: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-container {\n    padding: 10px;\n  }\n\n  .login-left {\n    padding: 30px 20px;\n  }\n\n  .login-right {\n    padding: 30px 20px;\n  }\n\n  .company-name {\n    font-size: 24px;\n  }\n\n  .welcome-title {\n    font-size: 20px;\n  }\n}\n\n/* Focus styles for accessibility */\n.submit-button:focus-visible,\n.form-input:focus-visible,\n.password-toggle:focus-visible {\n  outline: 2px solid #0d5787;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
